<template>
  <v-div
    class="PublicationInformation"
    :border-inverted-bottom-thick="!lastItem"
    mt-3
    pb-3
  >
    <h2 class="mb-2 ml-2 font-weight-bold font-smaller">Publication</h2>
    <v-div pl-2 font-smaller
      >This content is an early or alternative research output and has not been
      peer-reviewed at the time of posting.</v-div
    >
  </v-div>
</template>

<script>
export default {
  name: "PublicationInformation",
  props: {
    article: { type: Object, required: true },
    lastItem: { type: Boolean, default: false },
  },
};
</script>
